module.exports = __webpack_public_path__ + "dd3d353c9e198e271410d1cc9da4f5df.pdf";